import Plan from "./Plan";
import "./_plan.scss";
export default Plan;
